import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist over the CatalogItem EC, used to bind a source-derived lookup to the catalog
// item whose column supplies its values.
//
// Display = the item's Name (schema.table, as harvested); value = CatalogItemUSID, the LOGICAL item
// rather than a revision, so the binding survives every re-harvest on that end. rebuild_lookup
// resolves the binding through the item's CURRENT revision for exactly the same reason.
//
// SCOPED BY THE ACTIVE PERSONA, because the CatalogItem EC carries the visibility headers on its own
// query -- which matters here more than in most pickers: binding a lookup publishes that column's
// distinct values to the whole realm, so offering an item the caller cannot see would be offering
// them a way to read it. The server refuses that binding anyway (CC-LKUP-ITEM, checked at both save
// and rebuild); this keeps it off the menu rather than leaving the refusal to be discovered.
class CatalogItemPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "CatalogItem";
        this.static = false;
        this.enterpriseComponent = "CatalogItem";
        this.useRealm = false;
        // Current revisions only, so there is one row per logical item rather than one per revision
        // of it -- the picker is choosing a thing, not a version of it.
        this.searchSpecification = {"IsCurrent": true};
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "CatalogItemUSID";
        this.allowNoSelection = false;

        // PERSONA-SCOPED, and this flag is the whole mechanism -- PlatformSelect only puts the
        // active visibility onto the picklist's component when visibilityType is set, and the
        // CatalogItem component forwards it as the visibility-mode / visibility-value headers.
        // Without it the picker lists EVERY catalog item in the realm: caught in the browser, where
        // the converted form offered fifty raw.* tables that the hand-rolled dialog it replaced had
        // never shown, because that one passed the headers by hand.
        this.visibilityType = "Persona";
    }
}

export default CatalogItemPicklistMetadata;
